// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/MensagensProgramadas_DeleteScheduledMessageResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for deleteScheduledMessage() /mensagens_programadas/deleteScheduledMessage
 * Returns a success message after cancelling a scheduled message.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface MensagensProgramadas_DeleteScheduledMessageResponseDados {
message?: string
}

export type MensagensProgramadas_DeleteScheduledMessageResponse = ApiResponse<MensagensProgramadas_DeleteScheduledMessageResponseDados>;

registerResponseContract('MensagensProgramadas_DeleteScheduledMessageResponse', {
  message: { type: 'string',  required: false },
})
